import moment from 'moment';
import translation from '../assets/locales.json';
import config from '../../src/config';
import { POLICY_TYPES } from '../constants/constants';

export const sortAlphabetically = arr => {
  return arr.sort((a, b) => {
    if (a.toLowerCase() < b.toLowerCase()) return -1;
    if (a.toLowerCase() > b.toLowerCase()) return 1;
    return 0;
  });
};

export const sortArrayObject = (arr, key) => {
  return arr.sort((a, b) => {
    if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
    if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
    return 0;
  });
};

export const getPoliciesList = (policies, lang) => {
  const policiesList = policies.map(({ policyName, policyNumber }) => {
    return {
      id: policyNumber,
      value: policyName
        ? `${policyName[lang]} & ${policyNumber}`
        : policyNumber,
    };
  });
  const uniq = policiesList.filter(
    (item, index, self) => self.findIndex(t => t.id === item.id) === index,
  );
  return sortArrayObject(uniq, 'value');
};

export const prettifyRequestData = uglyHistoryData => {
  function isLessThan60DaysOld(compareDate) {
    const today = new Date().getTime();
    const compareDateInMS = Date.parse(compareDate);
    const sixtyDaysInMS = 24 * 60 * 60 * 1000 * 60;
    return today - compareDateInMS < sixtyDaysInMS;
  }

  const prettyResult = uglyHistoryData
    .map(aHistory => {
      let temp;
      if (aHistory.type === 'funds') {
        const {
          type,
          _id,
          requestType,
          policyNumber,
          dateRequested,
          financialDate,
          allocations,
        } = aHistory;
        temp = {
          type,
          id: _id,
          requestType,
          policyNumber,
          reportDateTime: dateRequested,
          displayDate: financialDate,
          allocations,
          statusCode: '',
          currencyCode: '',
          amountPaid: '',
          typeCode: '',
          referenceId: '',
        };
      } else if (aHistory.type === 'claims') {
        const {
          type,
          id,
          statusCode,
          currencyCode,
          amountPaid,
          typeCode,
          referenceId,
          reportDateTime,
        } = aHistory;

        temp = {
          type,
          id,
          statusCode,
          currencyCode: currencyCode || 'HKD',
          amountPaid,
          typeCode,
          referenceId,
          reportDateTime,
          displayDate: reportDateTime,
          requestType: '',
          policyNumber: '',
        };
      }

      return temp;
    })
    .filter(aHistory => {
      return isLessThan60DaysOld(aHistory.reportDateTime);
    })
    .sort((a, b) => {
      return b.reportDateTime > a.reportDateTime;
    });

  return prettyResult;
};

export const flattenArray = policies => {
  return [].concat(...policies);
};

export const getSelectedPolicies = (history, selectedPolicy) => {
  if (!selectedPolicy) {
    return history;
  }

  const historyFromOnePolicy = history.filter(
    item => item.policyNumber === selectedPolicy,
  );
  return historyFromOnePolicy;
};

export const filterTransactionsPerPolicy = transaction => {
  return transaction
    .sort(
      (a, b) =>
        new Date(b.financialDate).getTime() -
        new Date(a.financialDate).getTime(),
    )
    .slice(0, 3);
};

export const sortTransactionsByDate = transaction => {
  const nullFirstRule = (a, b) => {
    if (a.fundTxDate === null) {
      return -1;
    } else if (b.fundTxDate === null) {
      return 1;
    }
    return a.fundTxDate < b.fundTxDate ? 1 : -1;
  };

  return transaction.sort(nullFirstRule);
};

export const formatNumber = (number, prefix = '') => {
  if (parseInt(number, 10) === 0) return '-';
  return `${prefix}${number}`;
};

export const checkIfNumberIsChinese = number => {
  return (
    (number.length === 11 && number.startsWith('1')) || number.length === 13
  );
};

export const checkIfNumberIsTaiwan = number => {
  return (
    (number.length === 9 && number.startsWith('9')) ||
    (number.length === 10 && number.startsWith('09')) ||
    (number.length === 12 && number.startsWith('886'))
  );
};

export const getCountryCode = (values, contactData) => {
  let countryCode = '';
  if (checkIfNumberIsChinese(contactData.mobiles[values.contactMethod])) {
    countryCode = '86';
  } else if (values[`telephoneCountryCode${values.contactMethod}`]) {
    countryCode = values[`telephoneCountryCode${values.contactMethod}`];
  } else {
    countryCode = '';
  }
  return countryCode;
};

export const getObject = array => {
  return {
    key: array[0],
    value: array[1],
  };
};

export const contactInfoMassage = data => {
  const op = [];

  Object.keys(data).forEach(key => {
    const obj = {};
    obj.label = data[key];
    obj.value = key;
    op.push(obj);
  });

  return op;
};

export const makeEmmaHeaderTitleCenter = () => {
  if (!config.isApp) {
    const ele = document.getElementsByClassName('smalltitle-cont');
    ele[0].style.cssText = 'text-align: center;';
  }
};

export const makeEmmaHeaderTitleLeft = () => {
  if (!config.isApp) {
    const ele = document.getElementsByClassName('smalltitle-cont');
    ele[0].style.cssText = 'text-align: left;';
  }
};

// get the locale language value
export const getLocaleLanguageValue = (key, lang) => {
  return translation[lang][key];
};

export const isIE = () => {
  return !!window.document.documentMode;
};

export function formatContactsToArray({
  mobiles,
  isMobileUsed,
  isEmailUsed,
  emails,
}) {
  const isEmailsUsed = {};
  const isMobilesUsed = {};
  const uniqueMobiles = [...new Set(mobiles)];

  for (let i = 0; i < isEmailUsed.length; i++) {
    isEmailsUsed[isEmailUsed[i].email] = isEmailUsed[i].status;
  }

  for (let i = 0; i < uniqueMobiles.length; i++) {
    const countryCodes = isMobileUsed.filter(
      item => item.mobile === uniqueMobiles[i],
    );
    const mobileNumber = uniqueMobiles[i];
    for (let j = 0; j < countryCodes.length; j++) {
      if (countryCodes[j].countryCode !== '') {
        if (!isMobilesUsed[mobileNumber]) {
          isMobilesUsed[mobileNumber] = {};
        }
        isMobilesUsed[mobileNumber][countryCodes[j].countryCode] =
          countryCodes[j].status;
      }
    }
  }

  const emailArray = emails.map((email, i) => {
    return {
      [email]: {
        k: email,
        v: isEmailsUsed[email],
        i,
      },
    };
  });
  const mobileArray = uniqueMobiles.map((mobile, i) => {
    return {
      [mobile]: {
        k: mobile,
        v: isMobilesUsed[mobile],
        i,
      },
    };
  });

  return { emails: emailArray, mobiles: mobileArray };
}

export function getCurrentUrlSuffix() {
  const urlPrefix = `/${config.webview.identityFEPath}/emma/`;
  // http://xxx/en/iam-fe/emma/find-my-policy/employee-benefit/axa-card-selected
  // => find-my-policy/employee-benefit/axa-card-selected
  const currentPageUrlPath = window.location.pathname.split(urlPrefix).pop();
  const searchString = window.location.search;
  return `${currentPageUrlPath}${searchString}`;
}

export function getShouldShowPicStatement(lobs, policyType) {
  // lobs exists when lob = pnc
  if (lobs) {
    // HKEMMA-62917: true if lobs contain EB
    const { EB } = lobs || {};
    return EB === 'Y';
  } 

  return policyType === POLICY_TYPES.company;
}

// return if username is to be free text field
export function getShouldShowUsernameField(policyType, insuredAccessFlag, selectContactFlag) {
  // if lobs contain IH or insured life (i.e. policyType === individual && lobs.LIFEOWN === 'N'),
  // then username field is radio option type instead of free text field
  return policyType === 'company' ||
    (policyType === POLICY_TYPES.individual && insuredAccessFlag === 'Y') ||
    selectContactFlag === 'N';
}

export function changeDobFormat(dob) {
  const dobFormat = moment(dob).format('YYYY/MM/DD')
  return dobFormat ? dobFormat : dob
}